import React from 'react';
import { Drawer, Card, Typography } from 'antd';
import { AimOutlined } from '@ant-design/icons';
import AutoCompleteSearch from '../AutoComplete';
import { locationList } from '../../common/utils';
import { SearchLocationSideBarProps } from '../../common/types';

const { Text } = Typography;

const SearchLocationSideBar: React.FC<SearchLocationSideBarProps> = (
  Props: any
) => {
  const placeholder = 'Search for Locations here..';
  const width = window.innerWidth;
  const deviceType =
    width < 768 ? 'mobile' : width >= 768 && width < 1024 ? 'tab' : 'desktop';
  return (
    <>
      <Drawer
        title={
          <AutoCompleteSearch
            onClose={Props.onClose}
            options={locationList}
            placeholder={placeholder}
          />
        }
        placement="left"
        closable={true}
        visible={Props.visible}
        height={'100%'}
        onClose={Props.onClose}
        width={deviceType !== 'mobile' ? 500 : '100%'}
      >
        <Card hoverable={true}>
          <Text type="warning">
            <AimOutlined style={{ paddingRight: 5 }} />
            Get current location
          </Text>
          <Typography>Using GPS</Typography>
        </Card>
      </Drawer>
    </>
  );
};

export default SearchLocationSideBar;
